import AppChrome from '../components/AppChrome'
import Hero from '../components/Hero'
import MainContent from '../components/MainContent'

export { getServerSideProps } from '../graphql/page'

function Page( { entry: page } ) {
  return (
    <AppChrome>
      <Hero alignWithMainContent>
        { page.title }
      </Hero>
      <MainContent 
        contentBlocks={ page.contentBlocks } 
      />
    </AppChrome>
  )
}

export default Page
